import Loader from './Loader';
import './DataTable.scss';

export default function DataTable({
    columns,
    rows = [],
    loading = false,
    emptyMessage = 'Нет данных',
    rowKey = 'id',
    pagination,
}) {
    const {
        total = 0,
        limit = 50,
        offset = 0,
        onPageChange,
    } = pagination || {};

    const currentPage = Math.floor(offset / limit) + 1;
    const totalPages = Math.max(1, Math.ceil(total / limit));
    const from = total === 0 ? 0 : offset + 1;
    const to = Math.min(offset + rows.length, total);

    return (
        <div className="data-table-wrap">
            <div className="data-table-scroll">
                <table className="data-table">
                    <thead>
                        <tr>
                            {columns.map((col) => (
                                <th key={col.key} style={col.width ? { width: col.width } : undefined}>
                                    {col.title}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan={columns.length}>
                                    <Loader text="Загрузка..." />
                                </td>
                            </tr>
                        ) : rows.length === 0 ? (
                            <tr>
                                <td colSpan={columns.length} className="data-table__empty">
                                    {emptyMessage}
                                </td>
                            </tr>
                        ) : (
                            rows.map((row) => (
                                <tr key={row[rowKey] ?? JSON.stringify(row)}>
                                    {columns.map((col) => (
                                        <td key={col.key}>
                                            {col.render
                                                ? col.render(row[col.key], row)
                                                : (row[col.key] ?? '—')}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>

            {pagination && total > 0 && (
                <div className="data-table__pagination">
                    <span className="data-table__range">
                        {from}
                        –
                        {to}
                        {' '}
                        из
                        {' '}
                        {total}
                    </span>
                    <div className="data-table__pages">
                        <button
                            type="button"
                            className="btn btn--outline btn--sm"
                            disabled={currentPage <= 1}
                            onClick={() => onPageChange(Math.max(0, offset - limit))}
                        >
                            Назад
                        </button>
                        <span className="data-table__page-num">
                            {currentPage}
                            {' '}
                            /
                            {' '}
                            {totalPages}
                        </span>
                        <button
                            type="button"
                            className="btn btn--outline btn--sm"
                            disabled={currentPage >= totalPages}
                            onClick={() => onPageChange(offset + limit)}
                        >
                            Вперёд
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
